<script lang="ts">
  import type { UserViewFrameContext } from "../../_shared/_logic/user-types"
  import ProfileTab from "../GeneralPage/tabs/ProfileTab"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: UserViewFrameContext
    activeTab: string
  }>()
</script>

{#if activeTab === "profile"}
  <ProfileTab {viewFrameContext} />
{/if}
